import { Badge, Grid, IconButton, Skeleton } from "@mui/material";
import StockCard from "components/ui/StockCard";
import Tooltip from "components/ui/Tooltip";
import { ReactComponent as Sort } from "assets/icons/sort.svg";
import { ReactComponent as Filter } from "assets/filter/filter.svg";
import { ReactComponent as InfoIcon } from "assets/icons/Bredcrum_Icon/infoIcon.svg";
import WhatsAppicon from "assets/icons/Clients_Flow_Icons/childHeaderIcons/WhatsAppicon";
import MessageIcon from "assets/icons/Clients_Flow_Icons/childHeaderIcons/MessageIcon";
import DownloadIcon from "assets/icons/Clients_Flow_Icons/childHeaderIcons/DownloadIcon";
import BillingSummaryModal from "../UiModal/BillingSummaryModal";
import { useState } from "react";
import ClientDynamicModal from "components/ui/ClientFlowModals/ClientDynamicModal";
import PurchaseCard from "components/ui/PurchaseCard";
import { ReactComponent as Due_Date } from "assets/icons/Clients_Flow_Icons/clientInnerCardIcons/due_date_Icon.svg";
import { transformStockData } from "utils/transformdata";
import ProductSkeleton from "components/ui/Skeleton/ProductSkeleton";
import { formatDateWithSuffix } from "utils/formatDate";
import { usePermissions } from "context/PermissionsContext";
import { findSpecificMenu, findSpecificSubMenu, isAllowed } from "utils/checkUserRigths";

const transformWipDesignData = (item) => {
  return {
    orderNo: item.BagNo || "",

    styleNo: item.StyleCode || "",

    orderRef: item.OrderNo,

    location: item.PoNo || "N/A",

    quality: `${item.GoldQlty || ""} / ${item.DiaQlty || ""}`,

    messageDate: formatDateWithSuffix(item.OrderDate),

    dueDate: formatDateWithSuffix(item.ExpDelDate),

    imageUrl: item.ImageUrl || item.ImageUrl || "",

    transformedImageUrl: item.TransformedImageUrl || item.ImageUrl || "",
  };
};

const ClientRightSection = ({ data, type, isLoading, JewelTransId, allData }) => {
  const cardStyle = {
    display: "flex",
    flexDirection: "column",
    backgroundColor: "transparent",
    borderRadius: "8px",
    boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
    overflow: "hidden",
    // border: "1px solid #e2e8f0",
    height: "100%",
    width: "100%",
    padding: "0px 0px 150px",
  };

  const cardHeaderStyle = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "0px 3px",
    backgroundColor: "transparent",
  };

  const headerIconStyle = {
    color: "#64748b",
    cursor: "pointer",
    // padding: "7px",
    borderRadius: "4px",
    transition: "background-color 0.2s",
    display: "flex",
    gap: "8px",
    alignItems: "center",
  };

  const cardContentStyle = {
    flex: 1,
    overflowY: "auto",
    // padding: "0px 0px 150px",
    display: "flex",
    flexWrap: "wrap",
    alignContent: "start",
    scrollbarWidth: "thin",
    scrollbarColor: "#333333 #000000",
  };

  const [open, setOpen] = useState(false);
  const permissions = usePermissions();
  const hasAccessToQuotes_OrdersShare = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permissions), "Quotes & Orders"), "share");
  const hasAccessToQuotes_OrdersDownload = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permissions), "Quotes & Orders"), "download");

  const [modalType, setModalType] = useState({
    open: false,
    type: "",
  });

  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => setOpen(false);
  // console.log("data?.header===>>>",data?.header)

  const isHeaderInvalid = !data?.header || data?.header === "undefined-undefined" || data?.header === "undefined - undefined" || !data?.header.includes("-");

  let headerName = data.header?.lastIndexOf("-") != -1 ? data?.header?.slice(0, data.header?.lastIndexOf("-")) : "";
  // let headerCount = data.header?.split("-").pop();
  let headerCount = data?.header && data?.header.includes("-") ? data?.header.split("-").pop() : "";

  let transactionNumber = data?.header?.split(" ")[0];
  return (
    <>
      <div style={cardStyle}>
        <div style={cardHeaderStyle}>
          {data.header !== "Select a card" ? (
            <h2 style={{ fontSize: "16px", fontWeight: 700, color: "#fff", lineHeight: "100%", display: "flex", alignItems: "center" }}>
              {
                <div>
                  {isLoading || isHeaderInvalid ? (
                    <Skeleton width={"80px"} height={"30px"} />
                  ) : (
                    <>
                      <span style={{ fontWeight: "300", fontFamily: "poppins", fontSize: "16px" }}>{headerName} -</span>
                      <span style={{ fontWeight: "600", fontFamily: "poppins", fontSize: "16px", marginLeft: "5px" }}>{headerCount}</span>
                    </>
                  )}
                </div>
              }
              {(type === "dues" || type === "ledger") && !isLoading && data?.items?.length > 0 && (
                <IconButton sx={{ p: 0, ml: 0.7 }} disableRipple disableFocusRipple onClick={handleOpen}>
                  <InfoIcon style={{ width: "16px", height: "16px" }} />
                </IconButton>
              )}
              <BillingSummaryModal open={open} onClose={handleClose} transactionNumber={transactionNumber} type={type} />
            </h2>
          ) : (
            <h2 style={{ fontWeight: "300", fontFamily: "poppins", fontSize: "16px" }}>Select Card</h2>
          )}
          {data?.header !== "Select a card" && (
            <div style={{ display: "flex", gap: "22px", alignItems: "center" }}>
              {data?.dueDate && (
                <div style={{ display: "flex", fontSize: "14px", fontWeight: 500, fontFamily: "Poppins", alignItems: "center", gap: "6px" }}>
                  <Due_Date width={"14px"} height={"14px"} /> {data?.dueDate}
                </div>
              )}
              {type !== "wip" && data?.items?.length > 0 && (
                <div style={headerIconStyle}>
                  {hasAccessToQuotes_OrdersShare && (
                    <Tooltip title="Whatsapp transaction report">
                      <div
                        onClick={() => {
                          setModalType({ open: true, type: "WhatsApp" });
                        }}
                      >
                        <WhatsAppicon height={"35px"} width={"35px"} />
                      </div>
                    </Tooltip>
                  )}
                  {hasAccessToQuotes_OrdersShare && (
                    <Tooltip title="Email transaction report">
                      <div
                        onClick={() => {
                          setModalType({ open: true, type: "Message" });
                        }}
                      >
                        <MessageIcon height={"35px"} width={"35px"} />
                      </div>
                    </Tooltip>
                  )}
                  {hasAccessToQuotes_OrdersDownload && (
                    <Tooltip title="Download transaction report">
                      <div
                        onClick={() => {
                          setModalType({ open: true, type: "Download" });
                        }}
                      >
                        <DownloadIcon height={"35px"} width={"35px"} />
                      </div>
                    </Tooltip>
                  )}
                </div>
              )}
            </div>
          )}
        </div>

        <div style={cardContentStyle}>
          {/* {!data?.items?.length && <ProductSkeleton count={10} />} */}

          {data?.header === "Select a card" && (
            <div
              style={{
                width: "100%",
                textAlign: "center",
                marginTop: "40px",
                color: "#ccc",
                fontSize: "20px",
                fontFamily: "Poppins",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              Select a transaction on the left to view details here
            </div>
          )}

          {/* 2. Card selected → loading shimmer */}
          {isLoading && <ProductSkeleton count={10} />}

          {/* 3. Card selected → No items returned */}
          {data?.items?.length === 0 && data?.header !== "Select a card" && !isLoading && (
            <div
              style={{
                width: "100%",
                textAlign: "center",
                marginTop: "40px",
                color: "#ccc",
                fontSize: "16px",
                fontFamily: "Poppins",
              }}
            >
              No Data Available
            </div>
          )}

          {data?.items?.map((item, index) => (
            <>
              <Grid item className="stock" key={index}>
                {/* <StockCard key={index} data={item} /> */}
                {/* {console.log("items===>>",item)} */}
                {type === "quote-order" || type === "wip" ? (
                  <PurchaseCard data={type === "wip" ? transformWipDesignData(item) : item} allData={allData} />
                ) : (
                  <StockCard key={index} data={transformStockData(item)} />
                )}
              </Grid>
            </>
          ))}
        </div>
      </div>
      <ClientDynamicModal
        open={modalType.open}
        handleClose={() => setModalType({ ...modalType, open: false })}
        onClick={() => setModalType({ ...modalType, open: false })}
        modalType={modalType.type}
        type={type}
        data={data}
        JewelTransId={JewelTransId}
      />
    </>
  );
};

export default ClientRightSection;
